import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-design-saturation-icon',
  templateUrl: './design-saturation.component.html'
})
export class DesignSaturationComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
